import { VideoPresets } from 'livekit-client'
import type { VideoPreset } from 'livekit-client'
import type { ScreenShareQuality, VideoQuality } from './types'

export type ScreenShareEncodingProfile = {
  width: number
  height: number
  maxBitrate: number
  maxFramerate: number
  contentHint: 'text' | 'motion'
  degradationPreference: RTCDegradationPreference
}

// `720p`/`1080p` favor smooth motion (video/games/scrolling): `motion` hint +
// `maintain-framerate` tells the encoder to drop resolution before it drops
// frame rate. `1440p` is the dedicated "sharp text/detail" mode — it trades
// frame rate for resolution on purpose (`maintain-resolution`), so it must
// stay opt-in rather than a default.
export const SCREEN_SHARE_PROFILES: Record<ScreenShareQuality, ScreenShareEncodingProfile> = {
  '720p': { width: 1280, height: 720, maxBitrate: 2_500_000, maxFramerate: 30, contentHint: 'motion', degradationPreference: 'maintain-framerate' },
  '1080p': { width: 1920, height: 1080, maxBitrate: 5_000_000, maxFramerate: 30, contentHint: 'motion', degradationPreference: 'maintain-framerate' },
  '1440p': { width: 2560, height: 1440, maxBitrate: 8_000_000, maxFramerate: 15, contentHint: 'text', degradationPreference: 'maintain-resolution' },
}

export function cameraPreset(quality: VideoQuality): VideoPreset {
  switch (quality) {
    case '360p': return VideoPresets.h360
    case '480p': return VideoPresets.h540
    case '720p': return VideoPresets.h720
    case '1080p': return VideoPresets.h1080
  }
}
